import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "create-sites" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: "https://www.payo.com.au/wp-content/uploads/2021/06/Frame.png" }, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "checkmark"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
      (_ctx.content != '')
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            innerHTML: _ctx.content
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSites, (site) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "checkbox",
            key: site.id
          }, [
            _createTextVNode(_toDisplayString(site.name) + " - " + _toDisplayString(site.location.address.join(", ").trim(" ")) + ", " + _toDisplayString(site.location.city) + ", " + _toDisplayString(site.location.postal_code) + " ", 1),
            (_ctx.title != _ctx.complete)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "checkbox",
                  name: "sites",
                  value: site.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authorisedSites) = $event))
                }, null, 8, _hoisted_6)), [
                  [_vModelCheckbox, _ctx.authorisedSites]
                ])
              : _createCommentVNode("", true),
            (_ctx.title != _ctx.complete)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.title != _ctx.loading && _ctx.title == _ctx.success && _ctx.title != _ctx.complete)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-success",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.authorise && _ctx.authorise(...args))),
              disabled: _ctx.disabled
            }, " Authorise ", 8, _hoisted_8))
          : _createCommentVNode("", true),
        (
            _ctx.title != _ctx.loading &&
            (_ctx.title == _ctx.error || _ctx.title == _ctx.authorisationError) &&
            _ctx.title != _ctx.complete
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-success",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.retry && _ctx.retry(...args))),
              disabled: _ctx.disabled
            }, " Try again ", 8, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}